import React from "react"
import AppModals from "../AppModal/AppModal"
import { ModalRouter } from "./types"
import { ModalStack, useModalStack } from "./use-modal-stack"

// const AppModals = dynamic(() => import("../AppModal/AppModal"))

export type ModalProviderProps = Omit<ModalStack, "dismissModal" | "onHistoryPopState">

const ModalProviderContext = React.createContext<ModalProviderProps>({
    closeModal: () => Promise.resolve(),
    closeModalAfterSubmit: () => Promise.resolve(),
    closeAllModals: () => Promise.resolve(),
    openModal: () => Promise.resolve(),
    lastModal: () => undefined,
    isOpen: () => false,
    isClosing: () => false,
    modals: [],
})
const { Provider } = ModalProviderContext

type Props = {
    router: ModalRouter
}

const ModalProvider: React.FC<React.PropsWithChildren<Props>> = ({ children, router }) => {
    const value = useModalStack(router, global)
    return (
        <Provider value={value}>
            {children}
            <AllModals modals={value.modals} />
        </Provider>
    )
}

const AllModals: React.FC<Pick<ModalProviderProps, "modals">> = ({ modals }) => {
    return (
        <>
            {modals.map((modalProps, index) => (
                <AppModals key={index} modalProps={modalProps} />
            ))}
        </>
    )
}

export { ModalProviderContext, ModalProvider }
